import {
  FieldInfo,
  hasFieldError,
  readOnlyTriggerClass,
  useFieldContext,
  useFormReadOnly,
  useIsFieldOptional,
} from './shared'
import { Combobox } from '../combobox'
import { FieldLabelRow } from './field-label-row'
import { useLingui } from '@lingui/react/macro'
import { cn } from '@/lib/utils'
import { HORIZONTAL_CONTROL_CLASS, HORIZONTAL_LABEL_CLASS, HORIZONTAL_ROW_CLASS } from './horizontal-field'

export default function SelectNumberField(props: {
  label: string
  options: { value: number; label: string }[]
  className?: string
  orientation?: 'vertical' | 'horizontal'
  optional?: boolean
  placeholder?: string
}) {
  const { t } = useLingui()
  const field = useFieldContext<number | null>()
  const formReadOnly = useFormReadOnly()
  const isOptional = useIsFieldOptional(field.name, props.optional)
  const isHorizontal = props.orientation === 'horizontal'

  const stringOptions = props.options.map((option) => ({
    value: option.value.toString(),
    label: option.label,
  }))

  return (
    <div className={cn(props.className, formReadOnly && readOnlyTriggerClass)}>
      <div className={isHorizontal ? HORIZONTAL_ROW_CLASS : 'grid gap-2'}>
        {props.label && (
          <FieldLabelRow
            label={props.label}
            htmlFor={field.name}
            hasError={field.state.meta.isTouched && !field.state.meta.isValid}
            optional={isOptional}
            compactOptional={isHorizontal}
            className={isHorizontal ? HORIZONTAL_LABEL_CLASS : undefined}
          />
        )}
        <div className={isHorizontal ? HORIZONTAL_CONTROL_CLASS : undefined}>
          <Combobox
            id={field.name}
            placeholder={formReadOnly ? '-' : props.placeholder}
            searchPlaceholder={t`Search...`}
            commandEmpty={t`No results found`}
            variant="outline"
            options={stringOptions}
            value={field.state.value?.toString() ?? ''}
            onChange={(val) => field.handleChange(val === '' ? null : Number(val))}
            isError={hasFieldError(field.state.meta)}
          />
          <FieldInfo fieldState={field.state} />
        </div>
      </div>
    </div>
  )
}
